import { isAxiosError } from 'axios'
import type { GetConsentsResponse } from '../types/consent.types'
import apiClient from './api-client'

export async function fetchConsentedVehicles(): Promise<GetConsentsResponse> {
  try {
    const { data } = await apiClient.get<GetConsentsResponse>('/v1/consents')
    return data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      return []
    }

    throw error
  }
}

export async function revokeConsent(consentId: string): Promise<void> {
  await apiClient.delete(`/v1/consent/${consentId}`)
}
